const { Dropzone } = require('dropzone');

Dropzone.autoDiscover = false;

let dropZone;

/**
 * Checks the added files
 * @param {HTMLElement} submitButtonElement Submit button element
 */
function checkFilesAdded(submitButtonElement) {
  const fileError = dropZone.files.reduce(
    (acc, f) => f.status === 'error' || acc,
    false
  );
  // eslint-disable-next-line no-param-reassign
  submitButtonElement.disabled =
    fileError || dropZone.files.length > dropZone.options.maxFiles;
}

/**
 * Process dropzone files
 * @returns {boolean} True if dropzone has files & they are processed, False otherwise
 */
function processFiles() {
  if (dropZone && dropZone.files && dropZone.files.length > 0) {
    dropZone.processQueue();
    return true;
  }
  return false;
}

module.exports = {
  /**
   * Initializes a dropzone
   * @param {HTMLElement} dropzoneElement Dropzone HTML Element
   * @param {HTMLElement} submitButtonElement Submit Button HTML Element
   */
  init(dropzoneElement, submitButtonElement) {
    if (!dropzoneElement) return;

    const form = submitButtonElement.closest('form');
    const url = form.getAttribute('action');
    if (!url) return;

    const { dictFileTooBig, dictMaxFilesExceeded } = dropzoneElement.dataset;
    if (!dictFileTooBig || !dictMaxFilesExceeded) return;

    dropZone = new Dropzone(dropzoneElement, {
      url,
      autoProcessQueue: false,
      uploadMultiple: true,
      parallelUploads: 2,
      maxFiles: window.FRONT_CONFIG.contactAttachmentMaxFiles,
      maxFilesize: window.FRONT_CONFIG.contactAttachmentMaxFileSize,
      dictMaxFilesExceeded,
      dictFileTooBig,
      acceptedFiles: window.FRONT_CONFIG.contactAttachmentAccept,
      addRemoveLinks: true,
      init() {
        this.on('sendingmultiple', (file, xhr, formData) => {
          const data = new URLSearchParams(new FormData(form));
          data.forEach((value, key) => {
            formData.append(key, value);
          });
          formData.append('platform', 'web');
        });
        this.on('successmultiple', (files, response) => {
          $(this.element).removeClass('error');
          const event = new CustomEvent('dropzone-success', {
            detail: response,
          });
          document.dispatchEvent(event);
          if (!response.error) {
            this.removeAllFiles(true);
          }
        });
        this.on('errormultiple', (files, response) => {
          $(this.element).addClass('error');
          files.forEach((file) => {
            $(file.previewElement)
              .find('.dz-error-message')
              .text(response.error?.errorText);
          });
          checkFilesAdded(submitButtonElement);

          const event = new CustomEvent('dropzone-error', { detail: response });
          document.dispatchEvent(event);
        });
        this.on('removedfile', () => {
          $(this.element).removeClass('error');
          checkFilesAdded(submitButtonElement);
        });
        this.on('addedfile', (file) => {
          if (this.files.length === this.options.maxFiles) {
            $(this.element).removeClass('error');
          }
          if (this.files.length > this.options.maxFiles) {
            this.removeFile(file);
          }
          checkFilesAdded(submitButtonElement);
        });
        this.on('reset', () => {
          $(this.element).removeClass('error');
          // eslint-disable-next-line no-param-reassign
          submitButtonElement.disabled = false;
        });
      },
    });
  },
  methods: {
    processFiles,
  },
};
